import { Grid } from '@wework/dieter-ui'
import SpaceType from '../SidebarBlocks/SpaceType'
import React from 'react'

export default function EditOther({ space, roomData, setRoomData }) {
  if (!space) {
    return null
  }
  return (
    <div>
      <Grid style={{ marginTop: 24 }}>
        <SpaceType
          space={space}
          setRoomData={setRoomData}
          roomData={roomData}
        />
      </Grid>
    </div>
  )
}
